import React from "react";

import { PaymentsHistory } from "features/PaymentsHistory";
import { PageTitle } from "shared/ui";

const PaymentsHistoryPage = () => {
    return (
        <>
            <PageTitle>История оплат</PageTitle>
            <PaymentsHistory />
        </>
    );
};

export default PaymentsHistoryPage;
